'use strict';

var templates = require('../templates');
var fobclient = require('..');
var PersonIdent = require('../entity').PersonIdent;

module.exports = function (connection) {
  return {
    byPersonIdentTypEquals: function byPersonIdentTypEquals(personidenttyp, additionalParams) {
      return templates.searchTemplate(connection)(PersonIdent, 'byPersonIdentTypEquals', 'personidenttyp')(personidenttyp, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(PersonIdent, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byWertEquals: function byWertEquals(wert, additionalParams) {
      return templates.searchTemplate(connection)(PersonIdent, 'byWertEquals', 'wert')(wert, additionalParams);
    },
    byWertLike: function byWertLike(wert, additionalParams) {
      return templates.searchTemplate(connection)(PersonIdent, 'byWertLike', 'wert')(wert, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(PersonIdent, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('personident')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/personIdent.js
// module id = wL4z
// module chunks = 0